var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 509.33 400.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.2,
    y1: 17.2,
    x2: 200.38,
    y2: 68.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 254.67,
    y1: 121.1,
    x2: 200.38,
    y2: 68.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 308.95,
    y1: 68.24,
    x2: 254.67,
    y2: 121.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 492.13,
    y1: 17.2,
    x2: 308.95,
    y2: 68.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 448.29,
    y1: 155.45,
    x2: 492.13,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 383.14,
    y1: 220.6,
    x2: 448.29,
    y2: 155.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 448.29,
    y1: 285.75,
    x2: 383.14,
    y2: 220.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 350.47,
    y1: 383.57,
    x2: 448.29,
    y2: 285.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 158.87,
    y1: 383.57,
    x2: 254.67,
    y2: 241.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 350.47,
    y1: 383.57,
    x2: 254.67,
    y2: 241.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 255.96,
    y1: 350.37,
    x2: 254.67,
    y2: 241.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61.04,
    y1: 285.75,
    x2: 158.87,
    y2: 383.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 126.19,
    y1: 220.6,
    x2: 61.04,
    y2: 285.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 126.19,
    y1: 220.6,
    x2: 61.04,
    y2: 155.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61.04,
    y1: 155.45,
    x2: 17.2,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 254.67,
    y1: 241.55,
    x2: 254.67,
    y2: 121.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 126.19,
    y1: 220.6,
    x2: 254.67,
    y2: 241.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 383.14,
    y1: 220.6,
    x2: 254.67,
    y2: 241.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 254.67,
    y1: 42.72,
    x2: 254.67,
    y2: 121.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.36 235.77 126.19 228.79 111.02 235.77 118 220.6 111.02 205.44 126.19 212.41 141.36 205.44 134.38 220.6 141.36 235.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.21 300.91 61.04 293.94 45.88 300.91 52.85 285.75 45.88 270.58 61.04 277.56 76.21 270.58 69.24 285.75 76.21 300.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.21 170.62 61.04 163.65 45.88 170.62 52.85 155.45 45.88 140.29 61.04 147.26 76.21 140.29 69.24 155.45 76.21 170.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.37 32.37 17.2 25.4 2.04 32.37 9.01 17.2 2.04 2.04 17.2 9.01 32.37 2.04 25.4 17.2 32.37 32.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "215.55 83.41 200.38 76.43 185.22 83.41 192.19 68.24 185.22 53.08 200.38 60.05 215.55 53.08 208.58 68.24 215.55 83.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "269.83 136.27 254.67 129.29 239.5 136.27 246.47 121.1 239.5 105.93 254.67 112.91 269.83 105.93 262.86 121.1 269.83 136.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "269.83 57.89 254.67 50.92 239.5 57.89 246.47 42.72 239.5 27.56 254.67 34.53 269.83 27.56 262.86 42.72 269.83 57.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "367.98 235.77 383.14 228.79 398.31 235.77 391.33 220.6 398.31 205.44 383.14 212.41 367.98 205.44 374.95 220.6 367.98 235.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "433.12 170.62 448.29 163.65 463.46 170.62 456.48 155.45 463.46 140.29 448.29 147.26 433.12 140.29 440.1 155.45 433.12 170.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "476.96 32.37 492.13 25.4 507.29 32.37 500.32 17.2 507.29 2.04 492.13 9.01 476.96 2.04 483.94 17.2 476.96 32.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "293.78 83.41 308.95 76.43 324.11 83.41 317.14 68.24 324.11 53.08 308.95 60.05 293.78 53.08 300.76 68.24 293.78 83.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "174.03 398.74 158.87 391.76 143.7 398.74 150.67 383.57 143.7 368.41 158.87 375.38 174.03 368.41 167.06 383.57 174.03 398.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "269.83 256.71 254.67 249.74 239.5 256.71 246.47 241.55 239.5 226.38 254.67 233.35 269.83 226.38 262.86 241.55 269.83 256.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "271.13 365.54 255.96 358.56 240.79 365.54 247.77 350.37 240.79 335.21 255.96 342.18 271.13 335.21 264.15 350.37 271.13 365.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "367.98 235.77 383.14 228.79 398.31 235.77 391.33 220.6 398.31 205.44 383.14 212.41 367.98 205.44 374.95 220.6 367.98 235.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "433.12 300.91 448.29 293.94 463.46 300.91 456.48 285.75 463.46 270.58 448.29 277.56 433.12 270.58 440.1 285.75 433.12 300.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "335.3 398.74 350.47 391.76 365.63 398.74 358.66 383.57 365.63 368.41 350.47 375.38 335.3 368.41 342.27 383.57 335.3 398.74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheWorld);
export default __webpack_public_path__ + "static/media/TheWorld.40f8b5f6424ee3ceaab966a3fa22c7b8.svg";
export { ForwardRef as ReactComponent };